import {
  Center,
  Image,
  Spinner,
  TableContainer,
  Table,
  Thead,
  ChakraProvider,
  Tbody,
  Td,
  Tr as ChakraTr
} from '@chakra-ui/react';
import React from 'react';
import { UsageTh } from './UsageTh';
import { Tr } from './Tr';

const FiltroTabelas = ({ dados, view_loading_update, resultado }) => {
  console.log('boletos', dados);

  const [rowClicked, setRowClicked] = React.useState('');

  const handleRowClick = (row) => {
    setRowClicked(row);
  };

  return (
    <>
      <ChakraProvider>
        <TableContainer>
          <Table fontSize="12px" size="sm" width="100%">
            <Thead>
              <ChakraTr>
                <UsageTh text="Nº Pedido" />
                <UsageTh text="Nº Único" />
                <UsageTh text="Data Entrada" />
                <UsageTh text="Tipo de Envio" />
                <UsageTh text="Limite de Produção" />
                <UsageTh text="Nome Parceiro" />
                <UsageTh text="Nome Vendedor" />
                <UsageTh text="Peso Total" />
                <UsageTh text="Qtd. Caixas" />
                <UsageTh text="Valor Nota" />
                <UsageTh text="Imprimir" isPrint />
                <UsageTh text="Nota Finalização" />
              </ChakraTr>
            </Thead>
            <Tbody>
              {view_loading_update ? (
                <ChakraTr>
                  <Td colSpan="12" textAlign="center">
                    <Spinner
                      thickness="4px"
                      speed="0.65s"
                      emptyColor="gray.200"
                      color="blue.500"
                      size="md"
                    />
                  </Td>
                </ChakraTr>
              ) : dados ? (
                dados?.map((data, idx) => {
                  idx = idx++;
                  return (
                    <Tr
                      key={idx}
                      data={data}
                      idx={idx}
                      resultado={resultado}
                      rowClicked={rowClicked}
                      handleRowClick={() => handleRowClick(data.numero_unico)}
                    />
                  );
                })
              ) : (
                <ChakraTr>
                  <Td colSpan={12}>
                    <Center>
                      <Image w="150px" h="150px" objectFit="cover" mx="auto" mt="50px" />
                    </Center>
                  </Td>
                </ChakraTr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </ChakraProvider>
    </>
  );
};

export default FiltroTabelas;
